<template>
  <Flex direction="column">
    <BaseCard gray>
      <Flex direction="column">
        <BaseCheckbox
          v-model="formData.settings.sales.thermalSupport"
          :label="
            $t('admin.invoices.permissions.support_thermal_printer')
          "
          v-test="'thermalSupport'"
        />
      </Flex>
    </BaseCard>
    <BaseCard gray>
      <Flex direction="column">
        <BaseInput
          v-model="formData.receiptHeader"
          type="textarea"
          :info="$t('admin.invoices_and_receipts.receipt_settings.header_description')"
          :label="$t('admin.invoices.content.header_title')"
          v-test="'receiptHeader'"
        />
        <BaseInput
          v-model="formData.invoiceFooterThermal"
          type="textarea"
          :label="$t('admin.invoices.content.footer_thermal_title')"
          v-test="'invoiceFooterThermal'"
        />
        <BaseText @click="showVariablesModal = true">
          {{ $t('admin.invoices.content.help_link') }}
        </BaseText>
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { inject, type Ref } from 'vue';
import type { InvoiceFormData } from './useInvoices';

const showVariablesModal = inject<Ref<boolean>>('showVariablesModal')!;
const formData = inject<InvoiceFormData>('formData')!;
</script>
